const isDevEnvironment = import.meta.env.DEV

type LogArgs = unknown[]

const createLogger =
  (method: 'log' | 'warn' | 'error' | 'debug') =>
  (...args: LogArgs): void => {
    if (!isDevEnvironment) return
    globalThis.console[method](...args)
  }

export const devLog = createLogger('log')
export const devWarn = createLogger('warn')
export const devError = createLogger('error')
export const devDebug = createLogger('debug')
export { isDevEnvironment }
